import { ICol } from "./../types";

// [todo]
export function getWidth(columns: ICol[], colspan: number, index: number) {
	if (!colspan) {
		return columns[index].width;
	}
	return columns.reduce((w, c, i) => {
		w += (i >= index && i < index + colspan) ? c.width : 0; return w;
	}, 0);
}